const initialState = {
  data: null,
  response: null,
  message: null
};

export function rolePermissionReducer(state = initialState, action) {
  const { type, data } = action;

  switch (type) {
    case "SUCCESS":
      return {
        ...state,
        status: 200,
        data: data,
        message: "Success"
      };
    case "FAILURE": {
      return {
        ...state,
        status: 400,
        data: [],
        message: "Something Went Wrong"
      };
    }

    default:
      return state;
  }
}
